// Managed by @exxatdesignux/home-link. Re-run `exxat-home link` to update it.
// Exxat Home's own component, from @exxatdesignux/home-shell. This product's previous
// file is kept beside this one as utility-bar-product-switcher.tsx.orig.
// Its stylesheet loads once, in its own cascade layer, from src/styles/globals.css.
import { HomeProductSwitcher } from "@exxatdesignux/home-shell"

export function UtilityBarProductSwitcher(props: { compact?: boolean; markOnly?: boolean } = {}) {
  return <HomeProductSwitcher slug="exam-management" home="https://exxat-ds-home.pages.dev" {...props} />
}
